import React from "react";
import async from "../components/Async";
import Profile from "../pages/Profile/Profile";
import MarkOrder from "../pages/MarkOrder/MarkOrder";
import PickerOrder from "../pages/PickerOrder/PickerOrder";
import AdminPicker from "../pages/AdminPicker/AdminPicker";
import PickerStats from "../pages/dashboards/PickerStats/PickerStats";
import PickerDashbaordPage from "../pages/dashboards/PickerDashboard/PickerDashbaord";
import CheckerDashboard from "../pages/dashboards/CheckerDashboard/CheckerDashboard";
import OfflinePage from "../pages/OfflinePage/OfflinePage";
import Packer from "../pages/PackerPage/Packer";
import {
  FiBox,
  FiBarChart,
  FiPackage,
  FiLayout,
  FiUnlock,
  FiUser,
} from "react-icons/fi";
import { BiPrinter } from "react-icons/bi";
import MissingMedDashboard from "../pages/dashboards/MissingMedDashboard/MissingMedDashboard";
import MissingMed from "../pages/MissingMed/MissingMed";
import PackerPage from "../pages/PackerPage/PackerPage";
import ColdChainDashboard from "../pages/dashboards/ColdChainDashboard/ColdChainDashboard";
import ColdChainPage from "../pages/ColdChainPage/ColdChainPage";
import LogisticDashboard from "../pages/dashboards/LogisticDashboard/LogisticDashboard";
import DispatchPage from "../pages/Dispatch/DispatchPage";
import DisPacker from "../pages/DisPackerPage/DisPacker";
import { GrDocumentCsv } from "react-icons/gr";
import ExportCSV from "../pages/ExportCSV/ExportCSV";
import ToPickerMultiBoxLoop from "../components/TOPickerMultiBoxLoop/ToPickerMultiBoxLoop.js";
import TOPickerOrder from "../pages/TOPicker/TOPO/TOPickerOrder.js";
import TOCheckerOrder from "../pages/TOChecker/TOCO/TOCheckerOrder.js";
import ToBoxChecker from "../components/Transfer Order/ToChecker/ToBoxChecker.js";
import TOBPMain from "../pages/TOBinTransfer/TOBinPicker/TOBPMain/TOBPMain.jsx";
import BinTable from "../pages/TOBinTransfer/components/BinTable/BinTable.jsx";
import ToBinRackerPage from "../pages/TOBinTransfer/ToBinRacker/ToBinRackerPage/ToBinRackerPage.jsx";
import ToBinRacking from "../pages/TOBinTransfer/ToBinRacker/ToBinRacking/ToBinRacking.js";
import PutAwayItems from "../pages/putAway/putAwayItems/PutAwayItems.jsx";
import PutAwayInvoices from "../pages/putAway/PutAwayInvoices/PutAwayInvoices.jsx";
import PackSlip from "../pages/PackSlip/index.jsx";
import PrintPackslip from "../pages/PackSlip/PrintPackslip.js";
import { HiOutlineNewspaper } from "react-icons/hi";
import {
  MdAddChart,
  MdAddShoppingCart,
  MdOutlineAllInbox,
  MdOutlineLibraryAdd,
} from "react-icons/md";
import { IoSearchSharp } from "react-icons/io5";
// Guards
const AuthGuard = async(() => import("../components/AuthGuard"));

// Auth components
const SignIn = async(() => import("../pages/auth/SignIn"));
const ResetPassword = async(() => import("../pages/auth/ResetPassword"));
const ChangePassword = async(() =>
  import("../pages/ChangePassword/ChangePassword.js")
);

// Dashboards components
const Default = async(() => import("../pages/dashboards/Default"));

// OrderId Marking Component
// const MarkOrder = async(() => import("../pages/MarkOrder/MarkOrder"));

// Proected routes
const ProtectedPage = async(() => import("../pages/protected/ProtectedPage"));

// statistics
const dashboardsRoutes = {
  id: "CHECKER_STATISTICS",
  path: "/statistics",
  icon: <FiBarChart />,
  containsHome: true,
  component: Default,
};

const CheckerDashboardRoute = {
  id: "LIVE_CHECKER",
  path: "/checker_dashboard",
  icon: <FiLayout />,
  containsHome: true,
  component: CheckerDashboard,
};

const MissingMedDashboardRoute = {
  id: "MISSING_MED_DASHBOARD",
  path: "/missing_med_dashboard",
  icon: <FiLayout />,
  containsHome: true,
  component: MissingMedDashboard,
};

const ColdChainDashboardRoute = {
  id: "COLDCHAIN_DASHBOARD",
  path: "/coldchain_dashboard",
  icon: <FiLayout />,
  children: null,
  component: ColdChainDashboard,
};

const pickerDashboardRoute = {
  id: "LIVE_PICKER",
  path: "/picker_dashboard",
  icon: <FiLayout />,
  containsHome: true,
  component: PickerDashbaordPage,
};

const MarkOrderRoutes = {
  id: "CHECKER_HOMEPAGE",
  path: "/markorder",
  icon: <FiBox />,
  children: null,
  component: MarkOrder,
};

const PickerRoutes = {
  id: "PICKER_HOMEPAGE",
  path: "/picker",
  icon: <FiBox />,
  children: null,
  component: PickerOrder,
  // component: ToChecker,
};

const CheckerToRoutes = {
  id: "CHECKER_TO_HOMEPAGE",
  path: "/checker-to",
  icon: <FiBox />,
  children: null,
  component: ToBoxChecker,
};

const TOPickerRoutes = {
  id: "TO_PICKER_HOMEPAGE",
  path: "/to-picker",
  icon: <MdOutlineLibraryAdd />,
  children: null,
  component: TOPickerOrder,
};

const TOPackSlipRoutes = {
  id: "TO_CONTAINER_PACKING",
  path: "/to-container-packing",
  icon: <MdOutlineAllInbox />,
  children: null,
  component: PackSlip,
};

const TOPrintPackSlipRoutes = {
  id: "PRINT_PACK_SLIP",
  path: "/print-pack-slip",
  icon: <BiPrinter />,
  children: null,
  component: PrintPackslip,
};

const TOCheckerRoutes = {
  id: "TO_CHECKER_HOMEPAGE",
  path: "/to-checker",
  icon: <IoSearchSharp />,
  children: null,
  component: TOCheckerOrder,
};

const DispatchRoutes = {
  id: "DISPATCH_ORDER",
  path: "/dispatch",
  icon: <FiBox />,
  children: null,
  component: DispatchPage,
};

const PickerDashboard = {
  id: "PICKER_STATISTICS",
  path: "/picker-statistics",
  icon: <FiBarChart />,
  children: null,
  component: PickerStats,
};

const AdminPickerRoutes = {
  id: "PICKER_ADMIN_HOMEPAGE",
  path: "/admin-picker",
  icon: <FiBox />,
  children: null,
  component: AdminPicker,
};

const authRoutes = {
  id: "Auth",
  path: "/",
  icon: <FiUnlock />,
  children: null,
  component: SignIn,
};

const MissingMedPageRoute = {
  id: "MissingMedPage",
  path: "/missingMed/:orderId/:warehouseId",
  children: null,
  component: MissingMed,
};

const ColdChainPageRoute = {
  id: "ColdChainPage",
  path: "/coldChainMark/:orderId",
  children: null,
  component: ColdChainPage,
};

const LogisticDashboardRoute = {
  id: "LOGISTIC_DASHBOARD",
  path: "/logistic_dashboard",
  children: null,
  icon: <FiLayout />,
  component: LogisticDashboard,
};

const PackerRoute = {
  id: "PACKER_HOMEPAGE",
  path: "/packer",
  icon: <FiPackage />,
  containsHome: true,
  component: Packer,
};

const TOBinPickerRoute = {
  id: "BIN_TO_BIN_PICK",
  path: "/to-bin-picker",
  icon: <MdAddShoppingCart />,
  containsHome: true,
  component: TOBPMain,
};

const TOBinRackerRoute = {
  id: "BIN_TO_BIN_RACK",
  path: "/to-bin-racker",
  icon: <MdAddChart />,
  containsHome: true,
  component: ToBinRackerPage,
};
const TOBinRackingRoute = {
  id: "TO_BIN_RACKING",
  path: "/to-bin-racking",
  icon: <FiPackage />,
  containsHome: true,
  component: ToBinRacking,
};
const PutAwayInvoiceRoute = {
  id: "PUT_AWAY_INVOICES",
  path: "/put-away-invoices",
  icon: <HiOutlineNewspaper />,
  containsHome: true,
  component: PutAwayInvoices,
};
const PutAwayRacking = {
  id: "PUT_AWAY_RACKING",
  path: "/put-away-racking/:vendorId/:billNumber",
  icon: <FiPackage />,
  containsHome: true,
  // component: TOBPMain,
  component: PutAwayItems,
};
const PackerProcessRoute = {
  id: "PACKER_PAGE",
  path: "/packer-process/:orderId",
  containsHome: true,
  component: PackerPage,
};

const profileRoutes = {
  id: "PROFILE",
  path: "/profile",
  icon: <FiUser />,
  component: Profile,
};
const checkerPickerCSV = {
  id: "CSV_EXPORT",
  path: "/CSVEXPORT",
  icon: <GrDocumentCsv />,
  component: ExportCSV,
};

const toPickerPickScreen = {
  id: "TO_PICKER_PICK",
  path: "/to-pick",
  icon: <GrDocumentCsv />,
  component: ToPickerMultiBoxLoop,
};

// This route is only visible while signed in
const protectedPageRoutes = {
  id: "Private",
  path: "/private",
  component: ProtectedPage,
  children: null,
  guard: AuthGuard,
};
const BoxNumberSearch = {
  id: "BOX_NUMBER_SEARCH",
  path: "/box_number_search",
  icon: <FiLayout />,
  containsHome: true,
  component: DisPacker,
};
const offlinePageRoutes = {
  id: "Offline",
  path: "/offline",
  component: OfflinePage,
  children: null,
};

// Dynamic Routes.
// const editOrderDynamicRoute = {
//   path: "/components/editsubstitute/:id",
//   component: EditOrder,
//   children: null,
// };

// const addmedicineDynamicRoute = {
//   path: "/components/addmedicine",
//   component: AddMed,
//   children: null,
// };

const resetPasswordDynamicRoute = {
  path: "/resetPassword",
  component: ResetPassword,
  children: null,
};

const changePasswordDynamicRoute = {
  path: "/changePassword",
  component: ChangePassword,
  children: null,
};
// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  MarkOrderRoutes,
  dashboardsRoutes,
  pickerDashboardRoute,
  CheckerDashboardRoute,
  profileRoutes,
  changePasswordDynamicRoute,
  PickerRoutes,
  CheckerToRoutes,
  DispatchRoutes,
  offlinePageRoutes,
  AdminPickerRoutes,
  TOPickerRoutes,
  TOCheckerRoutes,
  PickerDashboard,
  BoxNumberSearch,
  PackerRoute,
  MissingMedDashboardRoute,
  MissingMedPageRoute,
  PackerProcessRoute,
  ColdChainDashboardRoute,
  ColdChainPageRoute,
  LogisticDashboardRoute,
  checkerPickerCSV,
  toPickerPickScreen,
  TOBinPickerRoute,
  TOBinRackerRoute,
  TOBinRackingRoute,
  PutAwayInvoiceRoute,
  PutAwayRacking,
  TOPackSlipRoutes,
  TOPrintPackSlipRoutes,
];

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes, resetPasswordDynamicRoute];

// Routes that are protected
export const protectedRoutes = [protectedPageRoutes, BoxNumberSearch];

// Routes visible in the sidebar
export const sidebarRoutes = [
  MarkOrderRoutes,
  dashboardsRoutes,
  profileRoutes,
  PickerRoutes,
  DispatchRoutes,
  AdminPickerRoutes,
  TOPickerRoutes,
  TOCheckerRoutes,
  PickerDashboard,
  pickerDashboardRoute,
  CheckerDashboardRoute,
  BoxNumberSearch,
  PackerRoute,
  MissingMedDashboardRoute,
  ColdChainDashboardRoute,
  LogisticDashboardRoute,
  checkerPickerCSV,
  TOBinPickerRoute,
  TOBinRackerRoute,
  TOBinRackingRoute,
  PutAwayInvoiceRoute,
  PutAwayRacking,
  TOPackSlipRoutes,
  TOPrintPackSlipRoutes,
];
